export default "__VITE_ASSET__BciSklcj__"